<mat-toolbar
  class="flex items-center justify-between h-14 px-4 border-blue-900/10 shadow-none transition-all duration-300 dark:bg-[#0a1628] dark:border-blue-500/10">
  <div class="flex items-center">
    <button mat-icon-button (click)="onMenuToggleDispatch()"
      class="focus:outline-none flex items-center justify-center hover:bg-[#2B0000]/5 dark:hover:bg-blue-500/10 transition-colors rounded-lg">
      <mat-icon class="text-[#2B0000] dark:text-blue-100">menu</mat-icon>
    </button>

    <div class="ml-3 text-sm font-poppins font-semibold text-[#2B0000] dark:text-blue-100 whitespace-nowrap">
      <span>Bienvenido al CRM</span>
    </div>
  </div>

  <!-- Contenedor central para ventas pendientes -->
  <div class="flex items-center justify-center" *ngIf="
      isBACKOFFICETRAMITADOR() || isBACKOFFICE() || isBACKOFFICESEGUIMIENTO()
    ">
    <div class="flex items-center gap-1.5 md:gap-2.5 scale-90 md:scale-100">
      <!-- Dot con animación de pulso -->
      <span class="relative flex h-3 w-3">
        <span class="animate-ping absolute inline-flex h-full w-full rounded-full bg-green-500 opacity-75"></span>
        <span class="relative inline-flex rounded-full h-3 w-3 bg-green-600"></span>
      </span>
      <span
        class="text-blue-900 dark:text-blue-100 text-xs md:text-sm font-poppins font-medium whitespace-nowrap">Ventas
        Pendientes:</span>
      <span
        class="px-2 py-1 text-red-600 font-poppins font-bold bg-red-100 rounded-md dark:bg-red-900/20 dark:text-red-400 text-xs md:text-sm">{{
        ventasPendientes }}</span>
    </div>
  </div>
  <div class="flex items-center gap-2 md:gap-3">
    <app-boton-notificaciones *ngIf="isAuthorized"></app-boton-notificaciones>

    <!-- Botón de tema claro/oscuro bien alineado -->
    <button mat-icon-button
      class="!flex !items-center !justify-center !p-0 w-full h-full transition hover:bg-blue-900/5 dark:hover:bg-blue-500/10"
      (click)="toggleDarkMode()" [matTooltip]="
        isDarkMode ? 'Cambiar a tema claro' : 'Cambiar a tema azulino'
      ">
      <svg xmlns="http://www.w3.org/2000/svg" class="w-5 h-5 text-[#2B0000] dark:text-blue-100" viewBox="0 0 24 24"
        fill="currentColor">
        <path
          d="m21.067 11.857l-.642-.388zm-8.924-8.924l-.388-.642zM21.25 12A9.25 9.25 0 0 1 12 21.25v1.5c5.937 0 10.75-4.813 10.75-10.75zM12 21.25A9.25 9.25 0 0 1 2.75 12h-1.5c0 5.937 4.813 10.75 10.75 10.75zM2.75 12A9.25 9.25 0 0 1 12 2.75v-1.5C6.063 1.25 1.25 6.063 1.25 12zm12.75 2.25A5.75 5.75 0 0 1 9.75 8.5h-1.5a7.25 7.25 0 0 0 7.25 7.25zm4.925-2.781A5.75 5.75 0 0 1 15.5 14.25v1.5a7.25 7.25 0 0 0 6.21-3.505zM9.75 8.5a5.75 5.75 0 0 1 2.781-4.925l-.776-1.284A7.25 7.25 0 0 0 8.25 8.5zM12 2.75a.38.38 0 0 1-.268-.118a.3.3 0 0 1-.082-.155c-.004-.031-.002-.121.105-.186l.776 1.284c.503-.304.665-.861.606-1.299c-.062-.455-.42-1.026-1.137-1.026zm9.71 9.495c-.066.107-.156.109-.187.105a.3.3 0 0 1-.155-.082a.38.38 0 0 1-.118-.268h1.5c0-.717-.571-1.075-1.026-1.137c-.438-.059-.995.103-1.299.606z" />
      </svg>
    </button>
    <div class="hidden lg:flex items-center gap-1 text-xs font-poppins font-medium dark:text-blue-100"
      [class.hidden]="isMobile">
      <div class="w-8 h-8 flex items-center justify-center">
        <mat-icon class="text-[#2B0000] dark:text-blue-100 w-5 h-5" fontIcon="schedule"></mat-icon>
      </div>
      <span class="text-[#2B0000] dark:text-blue-100 font-poppins">PER {{ horaPeru | date : "h:mm a" }}</span>
      <span class="text-gray-500 mx-0.5 dark:text-gray-400">|</span>
      <span class="text-[#2B0000] dark:text-blue-100 font-poppins">ESP {{ horaEspana | date : "h:mm a" }}</span>
    </div>

    <div *ngIf="isAuthorized"
      class="flex items-center px-2 md:px-3 py-1.5 ml-1 rounded-lg border border-blue-900/10 shadow-sm transition-all duration-200 hover:bg-blue-50 dark:bg-[#0a1628] dark:border-blue-500/20 dark:hover:bg-blue-800/20 cursor-pointer"
      [matMenuTriggerFor]="userMenu" #menuTrigger="matMenuTrigger" (click)="onMenuTriggerClick()">
      <div
        class="relative w-7 h-7 md:w-8 md:h-8 mr-1.5 md:mr-2.5 rounded-full flex items-center justify-center bg-blue-900/5 overflow-hidden dark:bg-blue-500/10">
        <img class="inline-block size-9 rounded-full object-cover" [src]="
            user?.picture || 'https://preline.co/assets/img/160x160/img1.jpg'
          " [alt]="getFirstNameAndLastName()" (error)="onImageError($event)" />
      </div>

      <span
        class="hidden md:block text-sm font-poppins font-semibold text-[#2B0000] truncate max-w-[100px] lg:max-w-[150px] dark:text-blue-100"
        [class.hidden]="isMobile">
        {{ getFirstNameAndLastName() }}
      </span>

      <app-user-status *ngIf="user && user.id"></app-user-status>
    </div>

    <mat-menu #userMenu="matMenu" class="user-menu" xPosition="before" yPosition="below" [overlapTrigger]="false"
      (menuOpened)="onMenuOpened()">
      <div class="bg-white rounded-xl shadow-lg p-4 space-y-4 dark:bg-gray-800 w-64">
        <div class="flex flex-col items-center space-y-3">
          <div class="relative group">
            <div
              class="w-16 h-16 rounded-full bg-gradient-to-br from-blue-100 to-blue-200 dark:from-blue-800 dark:to-blue-900 flex items-center justify-center border-2 border-blue-200 dark:border-blue-700">
              <img [src]="
                  user?.picture ||
                  'https://preline.co/assets/img/160x160/img1.jpg'
                " [alt]="getFirstNameAndLastName()" class="w-14 h-14 rounded-full object-cover"
                (error)="onImageError($event)" />
            </div>
          </div>
          <div class="text-center">
            <h2 class="text-base font-semibold text-gray-900 dark:text-gray-100">
              {{ user?.nombre + " " + user?.apellido }}
            </h2>
            <p class="text-sm text-gray-600 dark:text-gray-400">
              {{ user?.role || "Rol no definido" }}
            </p>
          </div>
          <div class="flex space-x-3">
            <button class="p-1.5 rounded-lg hover:bg-blue-50 dark:hover:bg-blue-900/20 transition-colors"
              (click)="openFacebook()">
              <svg class="w-4 h-4 text-blue-600" fill="currentColor" viewBox="0 0 24 24">
                <path
                  d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z" />
              </svg>
            </button>
            <button class="p-1.5 rounded-lg hover:bg-pink-50 dark:hover:bg-pink-900/20 transition-colors"
              (click)="openInstagram()">
              <svg class="w-4 h-4" viewBox="0 0 48 48">
                <radialGradient id="insta-grad" cx="19.38" cy="42.035" r="44.899" gradientUnits="userSpaceOnUse">
                  <stop offset="0" stop-color="#fd5"></stop>
                  <stop offset=".328" stop-color="#ff543f"></stop>
                  <stop offset=".348" stop-color="#fc5245"></stop>
                  <stop offset=".504" stop-color="#e64771"></stop>
                  <stop offset=".643" stop-color="#d53e91"></stop>
                  <stop offset=".761" stop-color="#cc39a4"></stop>
                  <stop offset=".841" stop-color="#c837ab"></stop>
                </radialGradient>
                <path fill="url(#insta-grad)"
                  d="M34.017,41.99l-20,0.019c-4.4,0.004-8.003-3.592-8.008-7.992l-0.019-20 c-0.004-4.4,3.592-8.003,7.992-8.008l20-0.019c4.4-0.004,8.003,3.592,8.008,7.992l0.019,20 C42.014,38.383,38.417,41.986,34.017,41.99z">
                </path>
                <path fill="#fff"
                  d="M24,31c-3.859,0-7-3.14-7-7s3.141-7,7-7s7,3.14,7,7S27.859,31,24,31z M24,19c-2.757,0-5,2.243-5,5 s2.243,5,5,5s5-2.243,5-5S26.757,19,24,19z">
                </path>
                <circle cx="31.5" cy="16.5" r="1.5" fill="#fff"></circle>
                <path fill="#fff"
                  d="M30,37H18c-3.859,0-7-3.14-7-7V18c0-3.86,3.141-7,7-7h12c3.859,0,7,3.14,7,7v12 C37,33.86,33.859,37,30,37z M18,13c-2.757,0-5,2.243-5,5v12c0,2.757,2.243,5,5,5h12c2.757,0,5-2.243,5-5V18c0-2.757-2.243-5-5-5H18z">
                </path>
              </svg>
            </button>
            <button class="p-1.5 rounded-lg hover:bg-gray-50 dark:hover:bg-gray-800 transition-colors"
              (click)="openTikTok()">
              <svg class="w-4 h-4 text-gray-900 dark:text-white" fill="currentColor" viewBox="0 0 24 24">
                <path
                  d="M19.589 6.686a4.793 4.793 0 0 1-3.77-4.245V2h-3.445v13.672a2.896 2.896 0 0 1-5.201 1.743l-.002-.001.002.001a2.895 2.895 0 0 1 3.183-4.51v-3.5a6.329 6.329 0 0 0-5.394 10.692 6.33 6.33 0 0 0 10.857-4.424V8.687a8.182 8.182 0 0 0 4.773 1.526V6.79a4.831 4.831 0 0 1-1.003-.104z" />
              </svg>
            </button>
          </div>
        </div>

        <div class="py-3 border-y border-gray-200 dark:border-gray-600 space-y-2">
          <!-- 🔥 NUEVO: Grid responsive para 4 botones -->
          <div class="grid grid-cols-2 md:grid-cols-4 gap-1.5">
            <!-- 🔥 NUEVO: Botón Iniciar Asistencia -->
            <button (click)="onIniciarAsistencia()" [disabled]="asistenciaLoading || yaInicioAsistencia"
              [class]="getAsistenciaButtonClass()"
              class="flex flex-col items-center p-2 rounded-lg border transition-colors relative">
              <mat-icon class="mb-1 !text-base" [class]="
                  yaInicioAsistencia
                    ? 'text-green-600 dark:text-green-400'
                    : 'text-purple-600 dark:text-purple-400'
                ">{{
                yaInicioAsistencia ? "check_circle" : "play_circle"
                }}</mat-icon>
              <span class="text-xs font-medium text-center leading-tight" [class]="
                  yaInicioAsistencia
                    ? 'text-green-700 dark:text-green-300'
                    : 'text-purple-700 dark:text-purple-300'
                ">{{ yaInicioAsistencia ? "Iniciada" : "Iniciar" }}</span>
              <span class="text-[10px] opacity-75">Asistencia</span>
              <!-- 🔥 NUEVO: Indicador de estado requerido -->
              <span *ngIf="!yaInicioAsistencia"
                class="absolute -top-1 -right-1 bg-red-500 text-white text-[8px] w-3 h-3 rounded-full flex items-center justify-center">!</span>
              <div *ngIf="asistenciaLoading"
                class="absolute inset-0 bg-gray-200/50 dark:bg-gray-900/50 rounded-lg flex items-center justify-center">
                <div class="animate-spin rounded-full h-4 w-4 border-b-2 border-purple-600"></div>
              </div>
            </button>

            <!-- Break -->
            <button (click)="onBreakAction()" [disabled]="
                breakLoading ||
                (!puedeTomarBreak && !breakActivo) ||
                (!yaInicioAsistencia && !breakActivo) ||
                yaMarcoSalida
              " [class]="getBreakButtonClass()"
              class="flex flex-col items-center p-2 rounded-lg border transition-colors relative">
              <mat-icon class="mb-1 !text-base" [class]="
                  breakActivo
                    ? 'text-orange-600 dark:text-orange-400'
                    : 'text-yellow-600 dark:text-yellow-400'
                ">coffee</mat-icon>
              <span class="text-xs font-medium text-center leading-tight" [class]="
                  breakActivo
                    ? 'text-orange-700 dark:text-orange-300'
                    : 'text-yellow-700 dark:text-yellow-300'
                ">{{ breakActivo ? "Finalizar" : "Break" }}</span>
              <span class="text-[10px] opacity-75">({{ totalBreaks }}/2)</span>
              <!-- 🔥 MEJORADO: Indicadores de estado más claros -->
              <span *ngIf="breakActivo"
                class="absolute -top-1 -right-1 bg-orange-500 text-white text-[8px] w-3 h-3 rounded-full flex items-center justify-center animate-pulse">!</span>
              <span *ngIf="!yaInicioAsistencia && !breakActivo"
                class="absolute -top-1 -right-1 bg-gray-400 text-white text-[8px] w-3 h-3 rounded-full flex items-center justify-center">🔒</span>
              <div *ngIf="breakLoading"
                class="absolute inset-0 bg-gray-200/50 dark:bg-gray-900/50 rounded-lg flex items-center justify-center">
                <div class="animate-spin rounded-full h-4 w-4 border-b-2 border-orange-600"></div>
              </div>
            </button>

            <!-- Baño -->
            <button (click)="onBanoAction()" [disabled]="
                banoLoading ||
                (!puedeIrAlBano && !banoActivo) ||
                (!yaInicioAsistencia && !banoActivo) ||
                yaMarcoSalida
              " [class]="getBanoButtonClass()"
              class="flex flex-col items-center p-2 rounded-lg border transition-colors relative">
              <mat-icon class="mb-1 !text-base" [class]="
                  banoActivo
                    ? 'text-blue-600 dark:text-blue-400'
                    : 'text-cyan-600 dark:text-cyan-400'
                ">wc</mat-icon>
              <span class="text-xs font-medium text-center leading-tight" [class]="
                  banoActivo
                    ? 'text-blue-700 dark:text-blue-300'
                    : 'text-cyan-700 dark:text-cyan-300'
                ">{{ banoActivo ? "Finalizar" : "Baño" }}</span>
              <span class="text-[10px] opacity-75">({{ totalBanos }}/2)</span>
              <!-- 🔥 MEJORADO: Indicadores de estado más claros -->
              <span *ngIf="banoActivo"
                class="absolute -top-1 -right-1 bg-blue-500 text-white text-[8px] w-3 h-3 rounded-full flex items-center justify-center animate-pulse">!</span>
              <span *ngIf="!yaInicioAsistencia && !banoActivo"
                class="absolute -top-1 -right-1 bg-gray-400 text-white text-[8px] w-3 h-3 rounded-full flex items-center justify-center">🔒</span>
              <div *ngIf="banoLoading"
                class="absolute inset-0 bg-gray-200/50 dark:bg-gray-900/50 rounded-lg flex items-center justify-center">
                <div class="animate-spin rounded-full h-4 w-4 border-b-2 border-blue-600"></div>
              </div>
            </button>

            <!-- Salida -->
            <button (click)="onMarcarSalida()" [disabled]="
                salidaLoading ||
                yaMarcoSalida ||
                !yaInicioAsistencia ||
                totalBreaks < 2
              " [class]="getSalidaButtonClass()"
              class="flex flex-col items-center p-2 rounded-lg border transition-colors relative">
              <mat-icon class="mb-1 !text-base" [class]="
                  yaMarcoSalida
                    ? 'text-green-600 dark:text-green-400'
                    : 'text-red-600 dark:text-red-400'
                ">{{ yaMarcoSalida ? "check_circle" : "logout" }}</mat-icon>
              <span class="text-xs font-medium text-center leading-tight" [class]="
                  yaMarcoSalida
                    ? 'text-green-700 dark:text-green-300'
                    : 'text-red-700 dark:text-red-300'
                ">{{ yaMarcoSalida ? "Marcada" : "Salida" }}</span>
              <span class="text-[10px] opacity-75" *ngIf="horaSalida">{{
                horaSalida
                }}</span>
              <!-- 🔥 MEJORADO: Indicadores de estado más claros -->
              <span *ngIf="!yaInicioAsistencia && !yaMarcoSalida"
                class="absolute -top-1 -right-1 bg-gray-400 text-white text-[8px] w-3 h-3 rounded-full flex items-center justify-center">🔒</span>
              <span *ngIf="yaInicioAsistencia && totalBreaks < 2 && !yaMarcoSalida"
                class="absolute -top-1 -right-1 bg-yellow-500 text-white text-[8px] w-3 h-3 rounded-full flex items-center justify-center">{{
                totalBreaks }}</span>
              <div *ngIf="salidaLoading"
                class="absolute inset-0 bg-gray-200/50 dark:bg-gray-900/50 rounded-lg flex items-center justify-center">
                <div class="animate-spin rounded-full h-4 w-4 border-b-2 border-red-600"></div>
              </div>
            </button>

            <!-- 🔥 NUEVO: Botón de Emergencia -->
            <button (click)="onSalidaEmergencia()" [disabled]="
                emergenciaLoading || yaMarcoSalida || !yaInicioAsistencia
              "
              class="flex flex-col items-center justify-center p-2 rounded-lg border-2 border-red-300 bg-red-50 hover:bg-red-100 dark:border-red-600 dark:bg-red-900/20 dark:hover:bg-red-800/30 transition-colors relative disabled:opacity-50 disabled:cursor-not-allowed">
              <mat-icon class="mb-1 !text-base text-red-600 dark:text-red-400">emergency</mat-icon>
              <span class="text-xs font-medium text-center leading-tight text-red-700 dark:text-red-300">Papeleta</span>
              <span class="text-[10px] opacity-75 text-red-600 dark:text-red-400">Sin validar breaks</span>
              <!-- Indicador de estado -->
              <span *ngIf="!yaInicioAsistencia && !yaMarcoSalida"
                class="absolute -top-1 -right-1 bg-gray-400 text-white text-[8px] w-3 h-3 rounded-full flex items-center justify-center">🔒</span>
              <span *ngIf="yaInicioAsistencia && totalBreaks < 2 && !yaMarcoSalida"
                class="absolute -top-1 -right-1 bg-orange-500 text-white text-[8px] w-3 h-3 rounded-full flex items-center justify-center">⚠️</span>
              <span *ngIf="yaMarcoSalida"
                class="absolute -top-1 -right-1 bg-green-500 text-white text-[8px] w-3 h-3 rounded-full flex items-center justify-center">✅</span>
              <div *ngIf="emergenciaLoading"
                class="absolute inset-0 bg-red-200/50 dark:bg-red-900/50 rounded-lg flex items-center justify-center">
                <div class="animate-spin rounded-full h-4 w-4 border-b-2 border-red-600"></div>
              </div>
            </button>
          </div>
          <!-- 🔥 MEJORADO: Indicadores de estado más informativos -->
          <div class="text-center space-y-1">
            <!-- Estado de actividad activa -->
            <div *ngIf="breakActivo || banoActivo"
              class="inline-flex items-center space-x-1 bg-yellow-100 dark:bg-yellow-900/20 text-yellow-700 dark:text-yellow-300 rounded-full px-2 py-1 text-[10px] font-medium">
              <mat-icon class="!text-xs">{{
                breakActivo ? "coffee" : "wc"
                }}</mat-icon>
              <span>{{ breakActivo ? "En break" : "En baño" }} - Toque para
                finalizar</span>
            </div>

            <!-- Indicador de flujo de asistencias -->
            <div *ngIf="!yaInicioAsistencia"
              class="inline-flex items-center space-x-1 bg-red-100 dark:bg-red-900/20 text-red-700 dark:text-red-300 rounded-full px-2 py-1 text-[10px] font-medium">
              <mat-icon class="!text-xs">warning</mat-icon>
              <span>Debe iniciar asistencia primero</span>
            </div>

            <div *ngIf="yaInicioAsistencia && totalBreaks < 2 && !yaMarcoSalida"
              class="inline-flex items-center space-x-1 bg-blue-100 dark:bg-blue-900/20 text-blue-700 dark:text-blue-300 rounded-full px-2 py-1 text-[10px] font-medium">
              <mat-icon class="!text-xs">info</mat-icon>
              <span>Breaks completados: {{ totalBreaks }}/2 (requeridos para
                salida)</span>
            </div>
          </div>
        </div>

        <nav class="space-y-1">
          <button (click)="goToProfile()"
            class="w-full flex items-center space-x-3 px-3 py-2 rounded-lg transition-colors text-gray-700 hover:bg-gray-50 dark:text-gray-300 dark:hover:bg-gray-700">
            <mat-icon class="text-gray-500 dark:text-gray-400 !text-base">person</mat-icon>
            <span class="text-sm font-medium">Perfil</span>
          </button>

          <button (click)="goToAsistencias()"
            class="w-full flex items-center space-x-3 px-3 py-2 rounded-lg transition-colors text-gray-700 hover:bg-gray-50 dark:text-gray-300 dark:hover:bg-gray-700">
            <mat-icon class="text-gray-500 dark:text-gray-400 !text-base">access_time</mat-icon>
            <span class="text-sm font-medium">Asistencias</span>
          </button>
          <!--
          <button (click)="navigateToGmail()" class="w-full flex items-center space-x-3 px-3 py-2 rounded-lg transition-colors text-gray-700 hover:bg-gray-50 dark:text-gray-300 dark:hover:bg-gray-700">
            <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4 text-gray-500 dark:text-gray-400 ml-0.5" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"></path>
              <polyline points="22,6 12,13 2,6"></polyline>
            </svg>
            <span class="text-sm font-medium">Gmail</span>
          </button>
          -->
          <button (click)="onSignOut()"
            class="w-full flex items-center space-x-3 px-3 py-2 rounded-lg transition-colors text-red-600 hover:bg-red-50 dark:text-red-400 dark:hover:bg-red-900/20">
            <mat-icon class="text-red-500 !text-base">logout</mat-icon>
            <span class="text-sm font-medium">Cerrar Sesión</span>
          </button>
        </nav>
      </div>
    </mat-menu>
  </div>
</mat-toolbar>